const HTTPS_PREFIX = 'https://';

// Browsers strip ASCII tab/newline/carriage-return anywhere in a URL before parsing it, so a path
// like "/\n/evil.com" would reach the browser as "//evil.com" and bypass the protocol-relative check below.
const CONTROL_CHARACTER_PATTERN = /[\t\n\r]/;

export const isExternalAnnouncementHref = (href: string): boolean => {
  return href.startsWith(HTTPS_PREFIX);
};

const isParseableUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

/**
 * Allows an external `https://` URL or an in-app path with a single leading slash.
 * Rejects `javascript:`, `http:`, protocol-relative `//`, and a backslash after the slash. Returns null when rejected.
 */
export const getAnnouncementLinkHref = (url: string): string | null => {
  if (CONTROL_CHARACTER_PATTERN.test(url)) {
    return null;
  }

  if (isExternalAnnouncementHref(url)) {
    return isParseableUrl(url) ? url : null;
  }

  // A path starts with one slash. `//` is protocol-relative and `/\` is a backslash URL.
  if (url.startsWith('/') && url[1] !== '/' && url[1] !== '\\') {
    return url;
  }

  return null;
};
